import axios from 'axios'
import router from '../router'
import { Message, MessageBox  } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 在.env文件中配置
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const { status } = error.response
    console.log("request err", error)
    if (status === 401) {
      // 统一处理401错误
      Message.error('登录已过期，请重新登录')
      localStorage.removeItem('token')
      router.replace({
            path: '/login'
        });
    }else if(status == 409){

      MessageBox.confirm(
        '数据已更新，请刷新页面获取最新内容',
        '内容已更新',
        {
          confirmButtonText: '刷新页面',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        router.go(0)
      }).catch(() => {
        Message.error('数据已更新，请刷新后重试')
      })
      
      // 返回reject让调用方知道请求失败
      return Promise.reject(error.response?.data)

    }else if (status >= 500) {
      Message.error(error.response?.data.error|| '服务器错误')
    } else {
      if(status !== 400)
      {
        Message.error(error.response?.data.error|| '请求错误')
      }else{
        return Promise.reject(error.response?.data)
      }
    }
    return Promise.reject(error.response?.data)
  }
)

export default service